import script from "./Contact.vue?vue&type=script&setup=true&lang=js"
export * from "./Contact.vue?vue&type=script&setup=true&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=3e107456&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e107456"]])

export default __exports__